/**
 * Provisioning codes are generated as `KIOSK-` + 6 uppercase hex characters
 * and stored under that exact key. People type them on tablets and PCs, so the
 * launcher and the config API both normalize what was typed before using it:
 * whitespace removed, typographic dashes turned into `-`, letters uppercased.
 */
const TYPOGRAPHIC_DASHES = /[‐-―−]/g;

export function normalizeProvisionCode(input: string): string {
  return input.replace(/\s+/g, '').replace(TYPOGRAPHIC_DASHES, '-').toUpperCase();
}
